module.exports = __webpack_public_path__ + "img/delete.95aa071d.svg";